import { useState } from 'react';

import {
  dateMonthFormat,
  dateTimeFormatWithTimezone,
} from '../../../../shared/constants/apiDateFormat';
import {
  RevenueGeneralFilterFormValues,
  RevenueGeneralFilterValues,
} from '../DetailedRevenue.settings';
import { getMonthFirstDay, getMonthLastDay } from '../../../../shared/utils/dateUtils';

type UseRevenueGeneralFilterReturn = {
  generalFilters: RevenueGeneralFilterValues;
  applyGeneralFilters: (date: RevenueGeneralFilterFormValues) => void;
};

/**
 * Date range filter works with month range but api works with date range
 * so we need to convert month range to date range.
 * useRevenueGeneralFilter hook is used to convert month range to date range and add all other filters to the general filters.
 */
export const useRevenueGeneralFilter = (
  defaultFilters: RevenueGeneralFilterFormValues,
): UseRevenueGeneralFilterReturn => {
  const processGeneralFilters = ({
    firstMonth,
    lastMonth,
    ...rest
  }: RevenueGeneralFilterFormValues): RevenueGeneralFilterValues => {
    const formattedDateFrom = getMonthFirstDay(firstMonth, dateMonthFormat).format(
      dateTimeFormatWithTimezone,
    );

    const formattedDateTo = getMonthLastDay(lastMonth, dateMonthFormat).format(
      dateTimeFormatWithTimezone,
    );

    return { dateFrom: formattedDateFrom, dateTo: formattedDateTo, ...rest };
  };

  const [generalFilters, setGeneralFilters] = useState<RevenueGeneralFilterValues>(
    processGeneralFilters(defaultFilters),
  );

  const applyGeneralFilters = (date: RevenueGeneralFilterFormValues) => {
    setGeneralFilters(processGeneralFilters(date));
  };

  return { generalFilters, applyGeneralFilters };
};
